// The website home page's own bundle. The hero carousel reuses the `pane_slides` component the
// online apps' onboarding and nav panes use — see `app/views/home/_hero_carousel.html.erb` and
// `doc/README--scroll_snapping.md`.

import {paneSlidesLoader} from '@rankers/components/pane_slides/pane_slides_loader';
paneSlidesLoader();

import {homeHeroLoader} from '@rankers/components/home_hero/home_hero_loader';
homeHeroLoader();
